export default __webpack_public_path__ + "static/media/explore-world.59492fd7.svg";